"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StoreData;
require("core-js/modules/es.promise.js");
require("core-js/modules/es.json.stringify.js");
var _react = _interopRequireDefault(require("react"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _Config = require("./src/sec/Config");
var _EncDec = require("./src/sec/EncDec");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Basic routes and urls
/**
 * Store Data
 * @param {String} store 
 *  session, local or cookies
 * @param {Array} data 
 * ex. [{key: "test", value:"email@test.com", ..]
 */
async function StoreData(store) {
  let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let customStorage, final;
  let result = [];
  switch (store) {
    case 'local':
      // Check if Data exist in Storage
      customStorage = localStorage.getItem("data");
      if (customStorage) {
        // decrypt it first
        await (0, _EncDec.decryptSession)(customStorage).then(x => result = JSON.parse(x));
        // check if the same Key exist
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          let indexKey = result.findIndex(x => x.key === element.key);
          if (indexKey !== -1) {
            result[indexKey] = {
              key: element.key,
              value: element.value
            };
          } else {
            let nowLength = result.length;
            result[nowLength] = {
              key: element.key,
              value: element.value
            };
          }
        }
      } else {
        result = data;
      }
      return await (0, _EncDec.encryptSession)(JSON.stringify(result)).then(x => localStorage.setItem('data', x));
    case 'session':
      // Check if Data exist in Storage
      customStorage = sessionStorage.getItem("data");
      // Check if Data exist in Storage
      if (customStorage) {
        // decrypt it first
        await (0, _EncDec.decryptSession)(customStorage).then(x => result = JSON.parse(x));
        // check if the same Key exist
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          let indexKey = result.findIndex(x => x.key === element.key);
          if (indexKey !== -1) {
            result[indexKey] = {
              key: element.key,
              value: element.value
            };
          } else {
            let nowLength = result.length;
            result[nowLength] = {
              key: element.key,
              value: element.value
            };
          }
        }
      } else {
        result = data;
      }
      return await (0, _EncDec.encryptSession)(JSON.stringify(result)).then(x => sessionStorage.setItem('data', x));
    case 'cookies':
      // Check if Data exist in Storage
      customStorage = _jsCookie.default.get("data");
      if (customStorage) {
        // decrypt it first
        await (0, _EncDec.decryptSession)(customStorage).then(x => result = JSON.parse(x));
        // check if the same Key exist
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          let indexKey = result.findIndex(x => x.key === element.key);
          if (indexKey !== -1) {
            result[indexKey] = {
              key: element.key,
              value: element.value
            };
          } else {
            let nowLength = result.length;
            result[nowLength] = {
              key: element.key,
              value: element.value
            };
          }
        }
      } else {
        result = data;
      }
      return await (0, _EncDec.encryptSession)(JSON.stringify(result)).then(x => _jsCookie.default.set('data', x, {
        expires: _Config.expires,
        sameSite: 'strict',
        secure: true
      }));
    default:
      return false;
  }
}